import { useSelector } from "react-redux";
import EmailVerification from "./EmailVerification"
import { RootState } from "@store/reducers";
import { Check } from "lucide-react";
import CreateBasicProfile from "@pages/candidate/CreateBasicProfile/CreateBasicProfile";
import { createContext, Dispatch, SetStateAction, useState } from "react";

type Step = {
    label: string;
    isCompleted: boolean;
};

type CreateProfileContextValue = {
    steps: Step[];
    setSteps: Dispatch<SetStateAction<Step[]>>;
    activeStep: number
    setActiveStep: Dispatch<SetStateAction<number>>;
};

export const CreateProfileContext = createContext<CreateProfileContextValue | null>(null);

const CreateProfileLayout = () => {
    const { user } = useSelector((state: RootState) => state.auth);
    const isEmailVerified = user?.emailVerifiedAt

    const [steps, setSteps] = useState<Step[]>([
        {
            label: 'STEP 1',
            isCompleted: user?.firstName && user?.lastName
        },
        {
            label: 'STEP 2',
            isCompleted: user?.profilePic
        },
        {
            label: 'STEP 3',
            isCompleted: user?.industryType && user?.location && user?.jobTitle
        },
    ])

    const [activeStep, setActiveStep] = useState(1)

    return <CreateProfileContext.Provider
        value={{
            steps,
            setSteps,
            activeStep,
            setActiveStep
        }}
    >
        <div className="flex flex-col gap-3 rounded-md w-full">
            {/* Steps container */}
            <div className="flex items-center gap-5 h-[64px] rounded-3xl bg-white px-4">
                <div className={`flex p-2 gap-2 items-center rounded-full text-xs font-medium ${isEmailVerified ? 'text-green-800 bg-green-100' : 'text-blue-500 bg-blue-100'} border`}>
                    {
                        isEmailVerified ?
                            <div className={`rounded-full h-5 w-5 flex items-center justify-center border bg-green-800`}>
                                <Check size={12} color="white" />
                            </div>
                            :
                            <div className={`rounded-full h-5 w-5 flex items-center justify-center bg-white border border-blue-500`}>1</div>
                    }
                    Email address verified
                </div>



                {/* Steps */}
                {
                    isEmailVerified ?
                        <>
                            <div className={`flex p-2 gap-2 items-center rounded-full text-xs font-medium text-blue-500 bg-blue-100 border`}>
                                <div className={`rounded-full h-5 w-5 flex items-center justify-center bg-white border border-blue-500`}></div>
                                Complete basic profile
                            </div>
                            <div className="flex items-center">
                                {
                                    steps?.map((step, stepIndex) => {
                                        return <div
                                            key={step?.label}
                                            className="flex items-center">
                                            {
                                                stepIndex !== 0 ?
                                                    <div className="h-[1.5px] w-5 bg-blue-500 mx-2" />
                                                    :
                                                    null
                                            }
                                            <div className={`border rounded-full ${step?.isCompleted ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-500'} font-semibold px-3 py-1.5 text-xss`}>{step?.label}</div>
                                        </div>
                                    })
                                }
                            </div>
                        </>
                        :
                        null
                }

            </div>

            {/* Main body */}
            {
                !isEmailVerified ?
                    <EmailVerification />
                    :
                    <CreateBasicProfile
                        activeStep={activeStep}
                    />
            }
        </div>
    </CreateProfileContext.Provider>
}

export default CreateProfileLayout